const article = {
  slug: 'waitlist',
  title: 'Waitlist',
  section: 'Revenue',
  body: `
# Waitlist

When a requested size is full, add the prospect to the **waitlist**
with their contact info and desired unit type.

- When a matching unit frees up (move-out or status change), the
  waitlist surfaces the match so you can notify the prospect.
- Convert a waitlist entry straight into a rental when they commit.
- Entries keep timestamps, so first-come-first-served is defensible.
`,
};

export default article;
